var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1920 937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 1920,
    height: 937,
    transform: "translate(0 142)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(0 -142)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 307.887,
    cy: 319.407,
    rx: 307.887,
    ry: 319.407,
    transform: "translate(-531.879 153.593)",
    fill: "#96006b",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Decore",
    d: "M28.68,476.991C93.607,587.56,247.89,563.775,281.318,615.2s-21.857,187.068,74.57,238.5,43.713,149.783,160.068,210.853c93.084,48.856,318.637,58.5,419.778,57.213l49.5-772.7L902.306,0,28.68,129.855C7.037,208.71-23.262,388.535,28.68,476.991Z",
    transform: "translate(988.338 -145)",
    fill: "#ffe1c2",
    opacity: 0.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBanner);
export default __webpack_public_path__ + "static/media/home-banner.8b007bf062a6ff3031726eced3f02ba6.svg";
export { ForwardRef as ReactComponent };